import React from "react";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { LogInButton } from "../components/loginButton";
import { Navbar, Container, Row, Col, Card, Button } from "react-bootstrap";
import { Outlet, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress, Box, Typography } from "@mui/material";
import { useMyDetails } from "../hooks/useMyDetails";
import AccessDenied from "../components/AccessDenied";
import "./layout.css";

const AuthGate: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
	const { isLoading, isError, hasAdminAccess } = useMyDetails();

	if (isLoading)
		return (
			<Box
				display="flex"
				flexDirection="column"
				alignItems="center"
				mt="20vh"
			>
				<CircularProgress />
				<Typography sx={{ mt: 2 }} color="text.secondary">
					Checking access...
				</Typography>
			</Box>
		);
	if (isError)
		return (
			<Box display="flex" justifyContent="center" mt="20vh">
				<Typography color="error">
					Error loading user details. Please refresh.
				</Typography>
			</Box>
		);
	if (!hasAdminAccess) return <AccessDenied />;

	return <>{children}</>;
};

export const PageLayout = () => {
	const { instance, accounts } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const handleOpenHelp = () => {
		window.open(
			"https://sites.google.com/pymblelc.nsw.edu.au/parent-portal-2021-internal/admin/event-manager",
			"_blank"
		);
	};

	return (
		<>
			{isAuthenticated && (
				<>
					<Navbar bg="primary" variant="dark">
						<Col className="col-4">
							<Link className="navbar-brand" to="/">
								<img
									src="https://www.pymblelc.nsw.edu.au/wp-content/themes/pymblelc-2021/assets/images/plc-logo-white.svg"
									alt="Pymble Ladies College Logo"
									className="header-logo"
								/>
							</Link>
						</Col>
						<Col className="col-4 text-center">
							<h2 className="mt-1 pt-1 main-title">
								Event Manager
								<span onClick={handleOpenHelp} className="help-icon">
									&nbsp;
								</span>
							</h2>
						</Col>
						<Col className="col-4 align-right">
							{accounts && isAuthenticated ? (
								<span>
									Hi {accounts[0].name}!
									<Button
										variant="link"
										className="text-white ms-2 p-0"
										title="Sign out"
										onClick={() => instance.logoutRedirect()}
									>
										<FontAwesomeIcon icon={faRightFromBracket} />
									</Button>
								</span>
							) : (
								<LogInButton type="link" />
							)}
						</Col>
					</Navbar>
					<AuthGate>
						<Outlet />
					</AuthGate>
				</>
			)}
			{!isAuthenticated && (
				<Container className="login">
					<Row>
						<Col className="text-center">
							<Card bg="primary" className="loginContainer col-md-3" body>
								<h2 className="mb-3">
									Welcome to <br />
									Event Manager
								</h2>
								<LogInButton type={"light"} />
							</Card>
						</Col>
					</Row>
				</Container>
			)}
		</>
	);
};
